<div #trigger="cdkOverlayOrigin" cdkOverlayOrigin class="overlay-origin" class="flex flex-row flex-start-center">
  <ng-container *rxLet="liked$ as likedState">
    <button
      [ngClass]="{ liked: likedState }"
      (click)="like()"
      class="reactions-button"
      color="accent"
      data-test-id="reactions-button"
      mat-button
      type="button"
    >
      <div class="flex flex-row flex-center-center">
        @if (!likedState) {
          <img
            class="button-img-icon like-inactive"
            data-test-id="reactions-button-img-icon-inactive"
            src="assets/images/reactions/like-inactive.svg"
          />
        }
        @if (likedState) {
          <img
            class="button-img-icon {{ likedState?.toLowerCase() }}"
            data-test-id="reactions-button-img-icon-active"
            src="assets/images/reactions/{{ likedState?.toLowerCase() }}.svg"
          />
        }
        <span class="reactions-like-btn-text {{ likedState?.toLowerCase() }}" data-test-id="reactions-button-text">
          {{ likedState ? likedState : 'Like' }}
        </span>
      </div>
    </button>
  </ng-container>
</div>

<ng-template #reactionsPanel cdkConnectedOverlay>
  <div *rxLet="ractionsPanelVisibility$ as panelVisibilityState" class="reaction-menu-container">
    <div [ngClass]="{ hidden: !panelVisibilityState }" class="reaction-menu" data-test-id="reactions-menu">
      <ul class="flex flex-row flex-start-center">
        @for (reaction of reactions; track reaction) {
          <li class="flex flex-full">
            <div class="flex flex-col flex-between-center gap-12 reaction-item">
              <button
                (click)="react(reaction, true)"
                attr.data-test-id="reaction-button-{{ reaction }}"
                class="reaction-button flex flex-row flex-start-center"
              >
                <img
                  alt="{{ reaction }}"
                  class="reaction {{ reaction }}"
                  src="assets/images/reactions/{{ reaction }}.svg"
                />
              </button>
              <div class="reaction-title-container">
                <div class="reaction-title">{{ reaction }}</div>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</ng-template>
